import { graphHooks } from '@tunasong/graph-lib/react'
import { useCurrentUser } from '@tunasong/redux'
import type { Game, GameResult } from '@tunasong/schemas'

export const useGameResults = ({ game }: { game: Game }) => {
  const { userId } = useCurrentUser()
  const { entities: gameResults } = graphHooks.useEntityChildren<GameResult>({
    parentId: game.id,
    filter: 'gameresult',
    skip: !userId,
  })
  const userGameResults = gameResults.filter(result => result.userId === userId)
  return userGameResults
}
